<template>
    <div>
        <breadCrumb 
            :icon="'fa-chart-line'"
            :category="$t(`sideNav.navSalonReport`)"
            :subCategory="$t(`subMenu.salon_report_sales`)"
            :subSubCategory="''">
        </breadCrumb>
        <div class="row mt-3">
            <div v-show="showSummaryBox" class="col-sm-6 col-xl-3" v-for="box in salesReportSummaryBox" :key="box.id">
                <div class="p-3 rounded overflow-hidden position-relative text-white mb-g" :class="box.background">
                    <div class="">
                        <h3 class="fs-xxl d-block l-h-n m-0 fw-500">
                            {{box.value}}
                            <small class="m-0 l-h-n fw-400 text-capitalize">{{box.text}}</small>
                        </h3>
                    </div>
                    <i class="fal position-absolute pos-right pos-bottom opacity-15 mb-n1 mr-n1" :class="box.icon" style="font-size:5rem"></i>
                </div>
            </div>
        </div>
        <ul class="nav nav-tabs nav-tabs-clean px-3 px-sm-5 mt-3" role="tablist">
            <li class="nav-item" v-for="t in $i18n.messages[$i18n.locale].tab.reportSalesTabs" :key="t.id">
                <a class="nav-link bg-transparent fs-lg fw-400" :class="{'active': selectedTab == t.id}" @click="selectedTab = t.id">{{t.text}}</a>
            </li>
        </ul>
        <div class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr d-block pt-4 border-bottom-0">
                    <salesFilter ref="salesFilter" :tab="selectedTab" :commissionSalesItem="commissionItems" @filterSalesCommission="filterSalesCommission"></salesFilter>
                </div>
                <div class="panel-container show">
                    <div class="panel-content">
                        <div class="tab-content">
                            <salesItem ref="salesItem" class="tab-pane" :class="{'active': selectedTab == 'item'}" :commissionSalesItem="commissionItems" @setExportData="setExportData"></salesItem>
                            <salesDate  ref="salesDate" class="tab-pane" :class="{'active': selectedTab == 'date'}" :commissionSalesItem="commissionItems" @setExportData="setExportData" @setTotalData="setTotalData"></salesDate>
                        </div>
                    </div>
                </div> 
            </div>
        </div>
        <div :class="{'show': isModalShow}" class="modal fade">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content border-0 ">
                    <div class="modal-body text-center">
                        <div class="spinner-border text-light" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                        <div class="text-light mt-2">{{$t('message.data.fetching_wait')}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import _ from 'lodash';
import SalesFilter from './Sales_Filter'
import SalesItem from './Sales_Item'
import SalesDate from './Sales_Date'
import BreadCrumb from './../../Bread_Crumb'

import box from './../../../../assets/js/dashboard/salonReport/salonReport'

import {formatPrice} from './../../../../assets/js/dashboard/utilities'
import {handleSessionExpired, setSummaryBoxLabel} from './../../../../assets/js/dashboard/dashboard'

export default {
    name: "reportSales",
    components:{
        SalesFilter,
        SalesItem, SalesDate,
        BreadCrumb
    },
    data(){
        return{
            salesReportSummaryBox: [],
            selectedTab: "date",
            isModalShow: false,
            commissionItems: [],
            showSummaryBox: true,
            currentFilter: {},
        }
    },
    watch:{
        selectedTab(value){
            // this.$refs.salesFilter.setExportData(this.commissionItems, value);
            this.filterSalesCommission(this.currentFilter)
        },
        "$i18n.locale"(val){
            this.setSummaryBoxLabel()
        }
    },
    methods:{
        resetSummaryBox(){
            for(var m=0; m<this.salesReportSummaryBox.length; m++){
                this.salesReportSummaryBox[m].value = "-"
            }
        },
        setTotalData(data){
            for(var i=0; i<this.salesReportSummaryBox.length; i++){
                switch(this.salesReportSummaryBox[i].id){
                    case"sales":
                        this.salesReportSummaryBox[i].value = formatPrice(data.totalSales);
                        break
                    case"credit_redeem":
                        this.salesReportSummaryBox[i].value = formatPrice(data.totalCredits);
                        break
                    case"package_redeem":
                        this.salesReportSummaryBox[i].value = formatPrice(data.totalPackage);
                        break
                    case"total":
                        this.salesReportSummaryBox[i].value = formatPrice(data.subTotal);
                        break
                }
            }
        },
        setExportData(result){
            if(result && result['tab'] === this.selectedTab) {
                this.$refs.salesFilter.setExportData(result['data'], this.selectedTab);
            }
        },
        async filterSalesCommission(filter){
            this.currentFilter = filter

            this.isModalShow = true;
            
            if(this.selectedTab === "date") {
                var result = await this.getSummaryItems(filter)

                // this.$refs.salesFilter.setExportData(result['data'], this.selectedTab);
                this.$refs.salesDate.updateTable(result, filter);

                var filterObj = Object.assign({}, JSON.parse(JSON.stringify(filter)))
                filterObj.type = "all"
                var summaryResult = this.filterItems(result, filterObj)
                this.$refs.salesItem.getTotalData(summaryResult);

                this.showSummaryBox = filterObj['voided'] === 'voided' ? false : true
            } else {
                var result1 = await this.getListItems(filter)
                this.commissionItems = this.filterListItems(result1, filter)

                this.$refs.salesFilter.setExportData(this.commissionItems, this.selectedTab);
                this.$refs.salesItem.updateTable(this.commissionItems);

                var filterObj1 = Object.assign({}, JSON.parse(JSON.stringify(filter)))
                filterObj1.type = "all"
                var summaryResult1 = this.filterItems(result1, filterObj1)
                this.$refs.salesItem.getTotalData(summaryResult1);
            }

            this.isModalShow = false;
        },
        async getSummaryItems(objFilter){
            this.isModalShow = true

            var outletFilter = objFilter.outlet == "all" ? "" : "&outletID=" + objFilter.outlet
            var searchFilter = objFilter.search == "" ? "" : "&search=" + objFilter.search
            var voidFilter = objFilter.voided == "voided" ? "&active=0" : ""

            if(window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
                // objFilter.startDate = moment('01/08/2022', 'DD/MM/YYYY')
                // objFilter.endDate = moment('31/08/2022', 'DD/MM/YYYY')
            }

            var QUERY_STRING = "?start=" + moment(objFilter.startDate).unix() + 
            "&stop=" + moment(objFilter.endDate).unix() +
            outletFilter +  searchFilter + voidFilter
            const url =  "https://devm6.tunai.io/business/report/completed/date" + QUERY_STRING;

            var result = [];
            await this.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: this.$util.getSessionToken()}
            })
            .then(function(response) {
                result = response.data.dates;
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == "Invalid Token"){
                    handleSessionExpired();   
                }
            })

            var commissionItems = result
            this.isModalShow = false

            return commissionItems
        },
        filterItems(commissionItems, item){
            var filterByType = [];
            if(commissionItems.length != 0){
                if(item.type != "all"){
                    for(var i=0; i<commissionItems.length; i++){
                            if(commissionItems[i].redeem == item.type){
                                filterByType.push(commissionItems[i])
                            }
                        }
                }else{
                    filterByType = commissionItems;
                }
            }else{
                this.resetSummaryBox()
            }

            var filterByItemType = []
            if(filterByType.length != 0){
                if(item.itemType != "all"){
                    for(var j=0; j<filterByType.length; j++){
                            if(filterByType[j].item.type == item.itemType){
                                filterByItemType.push(filterByType[j])
                            }
                        }
                }else{
                    filterByItemType = filterByType;
                }
            }
            
            var filterByCategory = []
            if(filterByItemType.length != 0){
                if(item.category != "all"){
                    for(var k=0; k<filterByItemType.length; k++){
                            if(filterByItemType[k].item.category == item.category){
                                filterByCategory.push(filterByItemType[k])
                            }
                        }
                }else{
                    filterByCategory = filterByItemType;
                }
            }
            
            var filterBySubCategory = []
            if(filterByCategory.length != 0){
                if(item.folderID != "all"){
                    for(var l=0; l<filterByCategory.length; l++){
                            if(filterByCategory[l].item.folderID == item.folderID){
                                filterBySubCategory.push(filterByCategory[l])
                            }
                        }
                }else{
                    filterBySubCategory = filterByCategory;
                }
            }
            return filterBySubCategory
        },
        async getListItems(objFilter){
            this.isModalShow = true

            var outletFilter = objFilter.outlet == "all" ? "" : "&outletID=" + objFilter.outlet
            var searchFilter = objFilter.search == "" ? "" : "&search=" + objFilter.search
            var voidFilter = objFilter.voided == "voided" ? "&active=0" : ""

            var QUERY_STRING = "?startDate=" + moment(objFilter.startDate).format(this.$msg.CST.DATE_FORMAT) + 
            "&endDate=" + moment(objFilter.endDate).format(this.$msg.CST.DATE_FORMAT) +
            outletFilter +  searchFilter + voidFilter

            const url =  this.$api.REPORT_COMPLETED + QUERY_STRING;
            var result = [];
            await this.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: this.$util.getSessionToken()}
            })
            .then(function(response) {
                result = response.data.result;
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == "Invalid Token"){
                    handleSessionExpired();   
                }
            })

            var commissionItems = result
            this.isModalShow = false

            return commissionItems
        },
        filterListItems(commissionItems, item){
            var filterByType = [];
            if(commissionItems.length != 0){
                if(item && item.type != "all"){
                    for(var i=0; i<commissionItems.length; i++){
                            if(commissionItems[i].redeem == item.type){
                                filterByType.push(commissionItems[i])
                            }
                        }
                }else{
                    filterByType = commissionItems;
                }
            }else{
                this.resetSummaryBox()
            }

            var filterByItemType = []
            if(filterByType.length != 0){
                if(item && item.itemType != "all"){
                    for(var j=0; j<filterByType.length; j++){
                            if(filterByType[j].item.type == item.itemType){
                                filterByItemType.push(filterByType[j])
                            }
                        }
                }else{
                    filterByItemType = filterByType;
                }
            }
            
            var filterByCategory = []
            if(filterByItemType.length != 0){
                if(item && item.category != "all"){
                    for(var k=0; k<filterByItemType.length; k++){
                            if(filterByItemType[k].item.category == item.category){
                                filterByCategory.push(filterByItemType[k])
                            }
                        }
                }else{
                    filterByCategory = filterByItemType;
                }
            }
            
            var filterBySubCategory = []
            if(filterByCategory.length != 0){
                if(item && item.folderID != "all"){
                    for(var l=0; l<filterByCategory.length; l++){
                            if(filterByCategory[l].item.folderID == item.folderID){
                                filterBySubCategory.push(filterByCategory[l])
                            }
                        }
                }else{
                    filterBySubCategory = filterByCategory;
                }
            }
            return filterBySubCategory
        },
        setSummaryBoxLabel(){
            var _box = box.salesReportSummaryBox
            this.salesReportSummaryBox = setSummaryBoxLabel(this, 'sales', _box.slice())
        },
    },
    mounted(){
        let $vm = this;
        var data = {
            startDate: moment(),
            endDate: moment(), 
            outlet: "all",
            search: "",
            type: "",
            itemType: "all",
            category: "all",
            folderID: "all"
        }
        
        // $vm.filterSalesCommission(data)
        $vm.setSummaryBoxLabel()
        $vm.resetSummaryBox()
    }
}
</script>
<style scoped>
.nav-link{
    cursor: pointer;
}
.modal-content{
    background: transparent;
    box-shadow: none;
}
.show{
    display: block;
}
</style>